<template>
  <PageSeoData :title="$t('Blog')" />
  <section class="section blog">
    <h2>
      {{ $t("Blog") }}
    </h2>
    <div v-if="articles?.length" class="blog-content">
      <div
        v-for="article of articles"
        :key="`blog-article-${article.path}`"
      >
        <article>
          <img
            v-if="getArticleImage(article)"
            :src="getArticleImage(article)"
            alt="" 
          />
          <div>
            <p class="text-breadcrumbs">{{ getDate(article.meta?.date) }}</p>
            <LocLink :to="getRoutePath(article.path, locale)">
              <h5>{{ article.title }}</h5>
            </LocLink>
            <div class="blog-content__body">
              {{ getArticlePreview(article.body) }}
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { getDate, getRoutePath } from "~/utils/functions";
import LocLink from "~/components/lang/LocLink.vue";
import PageSeoData from "~/components/pageSeoData/PageSeoData.vue";
const { locale } = useI18n();

const { data: articles } = await useAsyncData(
  `blog-${locale.value}`,
  () => queryCollection("content")
    .where("path", "LIKE", `/${locale.value}/blog/%`)
    .where("path", "NOT LIKE", "%/.navigation")
    .order("stem", "DESC")
    .all(),
  { watch: [locale] }
);

function collectText(node: unknown): string {
  if (typeof node === "string") {
    return node;
  }

  if (Array.isArray(node)) {
    return node.map(collectText).join("");
  }

  return "";
}

function getArticlePreview(body: any): string {
  const firstParagraph = body?.value?.find(
    (node: unknown) => Array.isArray(node) && node[0] === "p"
  );

  return collectText(firstParagraph).trim();
}

function getArticleImage(article: any): string {
  return article?.meta?.image?.src ?? article?.image?.src ?? "";
}
</script>
